import React from 'react';
import { Typography } from 'antd';

import { renderNoukiDisplay } from 'src/utils/helper';
import { NumberFormatter } from 'src/utils/number';

interface QuoteDetailCellProps {
  detail: Response.QuotationPricingDetail;
  t: (key: string) => string;
}

const QuoteDetailCell: React.FC<QuoteDetailCellProps> = ({ detail, t }) => {
  if (!detail) return null;

  const unitPrice = detail.unitPrice?.split(' ')[1] || '';
  const totalTani = detail.totalPrice?.split(' ')[1] || '';

  return (
    <div className="quote-detail-cell">
      <div className="order-wrap">
        <p className="text-label">
          {t('pricing_page.estimate_results.estimate_number')}:
        </p>
        <p className="text-value">{detail.webMitrNo}</p>
      </div>
      <div className="order-wrap">
        <p className="text-label">
          {t('multiple_quotes_page.price_excluding_tax')}
        </p>
        <p className="text-value">
          {NumberFormatter.format(Number(detail.marumeHanbaiGaku), 18)}
          {unitPrice}
        </p>
      </div>
      <div className="order-wrap">
        <p className="text-label">
          {t('multiple_quotes_page.total_excluding_tax')}
        </p>
        <p className="text-value">
          {NumberFormatter.format(Number(detail.marumeSogaku), 18)}({totalTani})
        </p>
      </div>
      <div className="order-wrap">
        <p className="text-label"></p>
        <p className="text-value"></p>
      </div>
      {detail.mitsumoriTaxRes?.map((tax, idx) => (
        <div key={idx} className="order-wrap">
          <p className="text-label">{tax?.taxName} :</p>
          <p className="text-value">{`${tax?.zeikin}(${tax?.sogakuTani})`}</p>
        </div>
      ))}
      <Typography.Text className="form_label_no_required">
        {detail.displayToFullTax && (
          <>
            <div className="order-wrap">
              <p className="text-label">
                {t('multiple_quotes_page.total_tax_included')}
              </p>
              <p className="text-value">
                {NumberFormatter.format(Number(detail.marumeMitrGaku), 18)}
                {`(${totalTani})`}
              </p>
            </div>
          </>
        )}
        <div className="order-wrap">
          <p className="text-label">
            {t('multiple_quotes_page.delivery_date')}
          </p>
          <p className="text-value">
            {' '}
            {detail.noki !== 'EXTERNAL'
              ? detail.noki
              : renderNoukiDisplay(detail.noukiDisplay)}
          </p>
        </div>
      </Typography.Text>
    </div>
  );
};

export default QuoteDetailCell;
